import { ReactElement, FormEvent, useState } from 'react';
import { ImageUpload, PrimaryButton, Typography } from '@weareopenr/component-library';
import styles from './FileUploadForm.module.scss';

interface IFileUploadFormProps {
  formTitle: string;
  formMessage: string;
  isLoading?: boolean;
  onFormSubmit: ({ files }: { files: File }) => void;
}

const FileUploadForm = ({
  formTitle,
  formMessage,
  isLoading = false,
  onFormSubmit,
}: IFileUploadFormProps): ReactElement => {
  const [file, setFile] = useState<File | null>(null);
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleFileChange = (value: File | string | null) => {
    setFile(value instanceof File ? value : null);
    setValidationError(null);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!file) {
      setValidationError('This field is mandatory');
      return;
    }
    onFormSubmit({ files: file });
  };

  return (
    <form name="upload-form" className={styles['upload-form']} onSubmit={handleSubmit}>
      <Typography size="xxlarge" weight="semi-bold">
        {formTitle}
      </Typography>
      <div className={styles['upload-container']}>
        <ImageUpload image={file} setImage={handleFileChange} prompt={formMessage} uploadType="csv" />
        {validationError && (
          <Typography weight="regular" size="small" className={styles['error-message']}>
            {validationError}
          </Typography>
        )}
      </div>
      <PrimaryButton size="full-width" loading={isLoading} type="submit" data-cy="import-button">
        {isLoading ? 'Importing…' : 'Import'}
      </PrimaryButton>
    </form>
  );
};

export default FileUploadForm;
